import React from "react";
import { Card, Form, Input, Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from "../services/authService"; // ✅ use the service

export default function Login() {
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      const data = await loginAdmin(values); // ✅ call service

      if (data.token) {
        localStorage.setItem("adminToken", data.token);
        message.success("✅ Login successful!");
        navigate("/admin");
      } else {
        message.error("⚠️ Invalid response from server");
      }
    } catch (err) {
      console.error(err);
      message.error(err.response?.data?.message || "❌ Login failed");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f0f2f5",
      }}
    >
      <Card title="Admin Login" style={{ width: 350 }}>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, message: "Enter your email" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Enter your password" }]}
          >
            <Input.Password />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Login
          </Button>
        </Form>
      </Card>
    </div>
  );
}